import { Badge, FlexLayout } from '@deity/falcon-ui';
import type { IValidationResult } from '@deity-io/di-data-flows-editor';
import { Icon } from '@deity-io/portal-ui';
import { Tooltip } from 'components/Tooltip';
import type { FC } from 'react';
import styles from 'styling/badges.module.css';

const xxs: any = 'xxs';

type ValidationStatusBadgeProps = {
  validation: IValidationResult;
};
export const ValidationStatusBadge: FC<ValidationStatusBadgeProps> = ({ validation }) => {
  const isValid = validation.valid === true;

  const errorCounts = validation.messages?.reduce(
    (acc, item) => {
      if (item.type === 'error') {
        acc.errors += 1;
      } else if (item.type === 'warning') {
        acc.warnings += 1;
      }

      return acc;
    },
    { errors: 0, warnings: 0 }
  ) || { errors: 0, warnings: 0 };

  if (isValid) {
    return (
      <FlexLayout alignItems="center" width="full">
        <Badge py={xxs} fontWeight="bold" className={isValid ? styles.success : styles.inactive}>
          <FlexLayout alignItems="center" mr="xs" fontSize="xxs">
            <Icon icon="notStarted" sx={{ height: 18, width: 18 }} />
          </FlexLayout>
          {isValid ? 'VALID' : 'INVALID'}
        </Badge>
      </FlexLayout>
    );
  }

  return (
    <FlexLayout alignItems="center" width="full">
      <Tooltip
        direction="right"
        bgColor="#FFFFCC"
        color="black"
        content={`${errorCounts.errors} Errors
${errorCounts.warnings} Warnings `}
      >
        <Badge py={xxs} fontWeight="bold" className={isValid ? styles.success : styles.inactive}>
          <FlexLayout alignItems="center" mr="xs" fontSize="xxs">
            <Icon icon="notStarted" sx={{ height: 18, width: 18 }} />
          </FlexLayout>
          {isValid ? 'VALID' : 'INVALID'}
        </Badge>
      </Tooltip>
    </FlexLayout>
  );
};
